import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { LMContextService, LMLoggerService, LMUrlUtilService, URLOptions } from '@app/services';
import { Observable } from 'rxjs/internal/Observable';
import { catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { ListResource } from '@app/resources';

@Injectable()
export class LMListDropdownService {

  constructor(
    private httpClient: HttpClient,
    private lmContextService: LMContextService,
    private lmUrlUtilService: LMUrlUtilService,
    private lmLoggerService: LMLoggerService) {
  }

  public fetchData(options: LMListDropdownOptions, searchTerm: string): Observable<LMListDropdownDataResponse> {
    const listResource: ListResource = new ListResource({ busClassName: options.businessClass } );
    const urlOptions: URLOptions = { resource: listResource };
    const url = this.lmUrlUtilService.buildUrl(urlOptions);
    const request: LMListDropdownDataRequest = {
      requestType: 'RecordsAsStates'
    };

    if (searchTerm && searchTerm.trim().length > 0) {
      request.searchTerm = searchTerm;
      request.searchFields = options.searchFields;
    }

    if (options.selectList) {
      request.selectList = options.selectList;
    }

    return <Observable<LMListDropdownDataResponse>>this.httpClient
      .post(url, request).pipe(
        catchError(error => {
          this.lmLoggerService.error(error);
          return throwError(error || 'Server error');
        }));
  }
}
